import { render } from "./DashBoard.vue?vue&type=template&id=4dcb9256&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=4dcb9256&scoped=true&lang=css"
import "./DashBoard.vue?vue&type=style&index=1&id=4dcb9256&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcb9256"]])

export default __exports__